<template>
  <!-- 商品管理————组件 -->
  <el-dialog :title="title" :visible.sync="dialogFormVisible" :fullscreen="true" top="2vh" width="90%" @close="close"
    :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="div_form">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品线路" prop="kor_type">
          <el-select v-model="form.kor_type" style="width: 100%" placeholder="请选择" @change="kor_type_change">
            <el-option v-for="item in countryList" :key="item.type" :label="item.name" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品原产国家" prop="origin">
          <el-select v-model="form.origin" style="width: 100%" placeholder="请选择">
            <el-option v-for="(item, index) in origin_list[0]" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <!-- 商品分类 -->
        <el-form-item label="商品分类" prop="cid">
          <el-cascader @change="typeChagne" :props="props" v-model="form.cid" :options="typeList" style="width: 100%;">
          </el-cascader>
        </el-form-item>
        <!-- 韩国链接 -->
        <el-form-item label="韩国链接" prop="link">
          <el-input v-model.trim="form.link" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="税金" prop="tax">
          <el-input v-model.trim="form.tax" autocomplete="off" maxlength="8" show-word-limit
            @input="handleInput"></el-input>
        </el-form-item>
        <el-form-item label="自动下架时间" prop="removal_time">
          <el-date-picker v-model="form.removal_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间" style="width: 100%;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="每人限购">
          <el-input v-model.trim="form.single_user_max" autocomplete="off" maxlength="8" show-word-limit></el-input>
        </el-form-item>


        <el-form-item label="每单限购">
          <el-input v-model.trim="form.per_order_limit" autocomplete="off" maxlength="8" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="偏远省份" prop="">
          <el-select v-model="form.remote_city" multiple placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in provinceList" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="偏远地区运费" prop="">
          <el-input v-model.trim="form.remote_price" autocomplete="off" maxlength="8" show-word-limit
            @input="handleInput"></el-input>
        </el-form-item>

        <el-form-item v-if="isShow" label="添加时间" prop="update_time">
          <el-input v-model.trim="form.update_time" :disabled="true" autocomplete="off"></el-input>
        </el-form-item>
        <!-- 产品图片 -->
        <el-form-item label="产品图片" prop="pic">
          <uploadFile :limit="50" :img-list-string="form.pic" @fileChange="uploadChange($event, 'pic')" />
        </el-form-item>
        <el-form-item label="是否置顶" prop="top">
          <el-radio-group v-model="form.top">
            <el-radio :label="0">不置顶</el-radio>
            <el-radio :label="1">置顶</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否推荐" prop="recommend">
          <el-radio-group v-model="form.recommend">
            <el-radio :label="0">不推荐</el-radio>
            <el-radio :label="1">推荐</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否补价商品" prop="is_supplement">
          <el-radio-group v-model="form.is_supplement">
            <el-radio :label="0">普通商品</el-radio>
            <el-radio :label="1">补价商品</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品详情文本" prop="content">
          <div class="editor-wrapper">
            <!-- <el-upload class="quill-upload" :http-request="upload" action="#" :show-file-list="false" with-credentials
              accept="image/gif, image/jpeg, image/jpg, image/bmp, image/png" style="display: none">
              <i id="imgInput" class="el-icon-plus avatar-uploader-icon" />
            </el-upload> -->
            <quill-editor ref="myQuillEditor" v-model="form.content" :options="editorOption"
              @change="onEditorChange($event)" />
          </div>
          <!-- <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="form.content"> -->
          <!-- </el-input> -->
        </el-form-item>
        <el-form-item label="商品详情图片" prop="content_pic">
          <uploadFile :limit="20" :img-list-string="form.content_pic"
            @fileChange="uploadChange($event, 'content_pic')" />
        </el-form-item>
        <el-form-item label="商品规格" prop="recommend"></el-form-item>
        <el-form-item>
          <div v-for="(item, index) in SpecificationsList" :key="index" class="guige_item">
            <div class="guige_item_top">
              <div style="display: flex">
                <el-input v-model="item.name" style="width: 300px; margin-right: 15px" placeholder="请输入规格名"
                  autocomplete="off" @input="changeInput_sku($event, index)"></el-input>
                <el-button type="primary" @click="addSpecifications_item(index)">
                  添加规格项
                </el-button>
              </div>
              <el-button type="text" style="color: red" @click="delSpecifications(index)">
                删除
              </el-button>
            </div>
            <div class="guige_item_bottom">
              <el-input v-for="(ite, ind) in item.item" :key="ind" v-model="ite.text"
                style="width: 250px; margin-right: 15px" placeholder="请输入规格项" autocomplete="off"
                @input="changeInput($event, index, ind)">
                <el-button slot="append" icon="el-icon-error" @click="delSpecifications_item(index, ind)"></el-button>
              </el-input>
            </div>
          </div>
          <div>
            <el-button type="primary" @click="addSpecifications">
              添加规格
            </el-button>
            <el-button type="primary" @click="getSkuList">
              生成规格列表
            </el-button>
          </div>
        </el-form-item>
        <el-form-item v-if="skuList.length > 0" label="SKU列表">
          <el-table :data="skuList" border style="width: 100%">
            <el-table-column align="left" prop="sku" label="规格名" min-width="120"></el-table-column>
            <el-table-column align="center" label="规格图" min-width="120">
              <template slot-scope="scope">
                <div style="width: 100%; display: flex; justify-content: center">
                  <uploadFile :limit="1" maxlength="15" show-word-limit :img-list-string="scope.row.pic"
                    @fileChange="skuListPicChange($event, scope.$index)" />
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="备案号" min-width="120">
              <template slot-scope="{ row }">
                <el-input v-model="row.barcode"></el-input>
              </template>
            </el-table-column>

            <el-table-column align="center" label="价格" min-width="120">
              <template slot-scope="{ row }">
                <el-input v-model="row.price" @input="(e) => { row.price = $geShi(e) }" maxlength="10"
                  show-word-limit></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" label="库存" min-width="120">
              <template slot-scope="{ row }">
                <el-input v-model="row.stock" maxlength="10" show-word-limit></el-input>
              </template>
            </el-table-column>

            <el-table-column align="center" label="限购" min-width="120">
              <template slot-scope="{ row }">
                <el-input v-model="row.max_buy" maxlength="10" show-word-limit></el-input>
              </template>
            </el-table-column>


          </el-table>


          <el-pagination style="position: absolute; left: 0; right: 0; bottom: 20px; margin: auto"
            :current-page="queryForm.page" :layout="layout" :page-sizes="[20, 40, 60, 100]" :page-size="queryForm.limit"
            :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  goodsUpdate,
  goodsDetail,
  GoodsCate_list,
  index_brand,
  index_brand_types,
  Index_country_list,
  Index_origin,
  getCityList,
  goodsSkuList
} from '@/api/xgcApi'
import {
  getUploadUrl
} from '@/config'
import uploadFile from '@/components/uploadFileSpecification'
import {
  goodsAdd
} from '../../../api/xgcApi'
import exoprt_file from '@/utils/expor_file' // 导出excel文件
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{
    header: 1,
  },
  {
    header: 2,
  },
  ], // custom button values
  [{
    list: 'ordered',
  },
  {
    list: 'bullet',
  },
  ],
  [{
    script: 'sub',
  },
  {
    script: 'super',
  },
  ], // superscript/subscript
  [{
    indent: '-1',
  },
  {
    indent: '+1',
  },
  ], // outdent/indent
  [{
    direction: 'rtl',
  },], // text direction

  [{
    size: ['small', false, 'large', 'huge'],
  },], // custom dropdown
  [{
    header: [1, 2, 3, 4, 5, 6, false],
  },],

  [{
    color: [],
  },
  {
    background: [],
  },
  ], // dropdown with defaults from theme
  [{
    font: [],
  },],
  [{
    align: [],
  },],
  ['clean'], // remove formatting button
]

export default {
  name: 'UserManagementEdit',
  components: {
    uploadFile,
  },
  props: {
    // typeList: {
    //   type: Array,
    //   default: [],
    // },
  },
  data() {
    return {
      provinceList: [],
      saveLoading: false,
      origin_list: [],//原产国列表
      skuList_copy: [], //sku列表备份
      typeList: [],
      countryList: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'sub'
      },
      value: '',
      total: 0,
      layout: 'total, sizes, prev, pager, next, jumper',
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              // 重写点击组件上的图片按钮要执行的代码
              image: function (value) {
                document
                  .querySelector('.quill-upload .el-upload__input')
                  .click()
              },
            },
          },
        },
      },
      upUrl: '/index/index/file', //上传图片的接口
      editor: null,
      // 规格列表
      SpecificationsList: [
        // {
        //   name:'内存',
        //   item:[{text:'128GB'} , {text:'256GB'}  , {text:'1TB'}]
        // },
        // {
        //   name:'颜色',
        //   item:[{text:'白色'} , {text:'粉色'} , {text:'远山蓝'}]
        // }
      ],
      skuList: [], //规格列表
      form: {
        single_user_max: 0,
        per_order_limit: 0,
        b_type_id: null,
        removal_time: '',
        link: '',
        tax: '',
        kor_type: 0,
        type: 2,
        origin: 'KR',
        top: 0,
        recommend: 0,
        is_supplement: 0,
        remote_city: '', //偏远省份
        remote_price: '' //偏远地区加收费用
      },
      bidList: [], //商品品牌列表
      brand_typeList: [], //品牌类型列表
      dialogFormVisible: false,
      rules: {
        origin: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入原产国',
        }],
        kor_type: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择线路',
        },],
        cid: [{
          required: true,
          trigger: 'blur',
          message: '请选择商品分类'
        },
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value == 0) {
              callback(new Error('请选择商品分类'))
            } else {
              callback()
            }
          },
          trigger: 'blur',
        },
        ],
        tax: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入税金',
        }],
        // bid: [
        //   { required: true, trigger: 'blur', message: '请选择商品品牌' },
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (value == 0 || value == null || value == '') {
        //         callback(new Error('请选择商品品牌'))
        //       } else {
        //         callback()
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
        // b_type_id: [
        //   { required: true, trigger: 'blur', message: '请选择品牌类型' },
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (value == 0 || value == null || value == '') {
        //         callback(new Error('请选择品牌类型'))
        //       } else {
        //         callback()
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
        top: [
          {
            required: true,
            trigger: ['blur', 'change'],
            message: '请输入商品名称',
          }
        ],
        name: [{
          required: true,
          trigger: 'blur',
          message: '请输入商品名称',
        },],

        price: [{
          required: true,
          trigger: 'blur',
          message: '请输入商品金额',
        },],
        // type: [
        //   { required: true, trigger: 'change', message: '请选择商品类型' },
        // ],
        // pic: [{ required: true, trigger: 'blur', message: '请选择商品图片' }],
      },
      title: '',
      isShow: false,
      statusList: [
        // {
        //   value: 0,
        //   label: '快递费',
        // },
        {
          value: 1,
          label: '补价商品',
        },
        {
          value: 2,
          label: '普通商品',
        },
        // {
        //   value: 3,
        //   label: '预约拍照',
        // },
      ],
      queryForm: {
        goods_id: '',
        page: 1,
        limit: 20,
        name: '',
      },

    }
  },

  created() { },
  mounted() {
    this.getBidList()
    this.getType_list() //获取线路
    this.getProvinceList()//获取省份列表
  },
  methods: {
    kor_type_change() {
      this.form.cid = null
      this.form.bid = null
      this.form.b_type_id = null
      this.getTypelist()
      index_brand({
        kor_type: this.form.kor_type
      }).then((res) => {
        this.bidList = res.data
      })

    },
    getProvinceList() {
      getCityList({ pid: 0 }).then(res => {
        this.provinceList = res.data
      })
    },
    getTypelist() {
      var data = {
        page: 1,
        kor_type: this.form.kor_type
      }
      this.listLoading = true
      GoodsCate_list(data)
        .then((res) => {
          this.typeList = res.data
        })
        .catch((err) => {
          this.listLoading = false
        })
    },
    getType_list() {
      // 获取线路
      // Index_country_list
      var data = {}
      Index_country_list(data).then(res => {
        this.countryList = res.data
      })
    },
    typeChagne(e) {
    },
    getBidList() {
      index_brand({}).then((res) => {
        this.bidList = res.data
      })
    },
    bidChange(e) {
      this.form.bid = e
      this.form.b_type_id = ''
      index_brand_types({
        brand_id: e
      }).then((res) => {
        this.brand_typeList = res.data
      })
    },
    brand_typeChange(e) {
      this.form.b_type_id = e
    },
    // 将-字符换成_
    changeInput_sku(e, index) {
      this.SpecificationsList[index].name = this.SpecificationsList[
        index
      ].name.replace(/-/g, '_')
    },
    // 将-字符换成_
    changeInput(e, index, ind) {
      this.SpecificationsList[index].item[ind].text = this.SpecificationsList[
        index
      ].item[ind].text.replace(/-/g, '_')
    },
    // t添加规格项
    addSpecifications() {
      var item = {
        name: '',
        item: [],
      }
      this.SpecificationsList.push(item)
    },
    skuListPicChange(e, index) {
      if (e.length > 0) {
        this.skuList[index].pic = e[0]
      } else {
        this.skuList[index].pic = ''
      }
    },
    // 添加规格项
    addSpecifications_item(index) {
      var child = {
        text: '',
      }
      this.SpecificationsList[index].item.push(child)
    },
    // 删除规格
    delSpecifications(index) {
      this.SpecificationsList.splice(index, 1)
    },
    // 删除规格项
    delSpecifications_item(index, ind) {
      this.SpecificationsList[index].item.splice(ind, 1)
    },
    // 生成SKU列表
    getSkuList() {
      return new Promise((resolve, reject) => {
        var arr = []
        var ISok = true
        if (this.SpecificationsList.length == 0) {
          ISok = false
          this.$message({
            type: 'warning',
            message: '请添加规格',
          })
          reject('err')
          return
        } else {
          ISok = true
        }
        this.SpecificationsList.forEach((item, index) => {
          var sku_item = []
          item.item.forEach((ite, ind) => {
            if (ite.text) {
              sku_item.push(ite.text)
            } else {
              ISok = false
              this.$message({
                type: 'warning',
                message: '规格项不能为空',
              })
              reject('err')
              return
            }
          })
          arr.push(sku_item)
        })
        if (!ISok) {
          return
        }
        var sku_list = []
        if (arr.length > 1) {
          var sku_list_one = this.cartesianProduct(arr)
          sku_list_one.forEach((item, index) => {
            sku_list[index] = {
              name: item.join('-'),
              sku: item,
              stock: 0,
              max_buy: 0,
              barcode: '',
              pic: '',
              price: 0
            }
          })
        } else {
          this.SpecificationsList[0].item.forEach((item, index) => {
            sku_list[index] = {
              name: item.text,
              sku: item,
              stock: 0,
              max_buy: 0,
              barcode: '',
              pic: '',
              price: 0
            }
          })
        }
        if (this.skuList.length > 0) {
          sku_list = sku_list.map((aItem) => {
            var bItem = this.skuList.find(
              (bItem) => bItem.name === aItem.name
            )
            return {
              ...aItem,
              ...bItem
            }
          })
          this.skuList = sku_list
        } else {
          this.skuList = sku_list
        }
        resolve(this.skuList)
        return
      })
    },
    // 迪卡儿积算法
    cartesianProduct(sets) {
      return sets.reduce((a, b) => {
        return a.reduce((res, aItem) => {
          return res.concat(b.map((bItem) => [].concat(aItem, bItem)))
        }, [])
      })
    },
    /**
     *@name 富文本编辑器
     *@time 2024年4月23日15:01:58
     */
    // ---------------------------富文本编辑器开始--------------------------------------
    onEditorChange(e) { },
    upload(file) {
      // 图片上传
      file = file.file
      var data = {
        file: file,
      }
      var url = ''
      exoprt_file(this.upUrl, data).then((res) => {
        var pic = getUploadUrl + res
        let quill = this.$refs.myQuillEditor.quill
        // 获取光标所在位置
        let length = quill.getSelection().index
        // 插入图片 res.url为服务器返回的图片地址
        quill.insertEmbed(length, 'image', pic)
        // 调整光标到最后
        quill.setSelection(length + 1)
        // 调用编辑器的 insertEmbed 方法，插入URL
      })
    },
    handleInput() {
      // 移除非数字和非小数点字符，保留小数点
      this.form.tax = this.form.tax
        .replace(/[^\d.]/g, '')
        // 保留第一个小数点，移除其他小数点
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        // 移除前导零，但保留小数点前的单个零
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },
    // 上传图片
    uploadChange(e, key) {
      var strurl = e.join(',')
      strurl = strurl.replace('\\\\', '\/\/')
      strurl = strurl.replace('\\', '\/')
      strurl = strurl.replace('\\', '\/')
      this.form[key] = strurl
    },
    showEdit(row) {
      if (!row) {
        Index_origin({}).then(req => {
          this.origin_list = req.data
          // this.form.origin = 1
          this.title = '添加'
          this.isShow = false
          this.form.pic = ''
          this.value = ''
          this.getTypelist() //商品分类
          this.dialogFormVisible = true
        })

      } else {
        this.title = '编辑'
        this.isShow = true
        Index_origin({}).then(req => {
          this.origin_list = req.data
          // ------------------------
          goodsDetail({ id: row.id }).then(res => {
            var data = res.data
            data.cid = data.cid.split(',')
            data.cid.map((item, index) => {
              data.cid[index] = Number(item)
            })
            // this.value = data.content
            data.spec_list.forEach((item, index) => {
              data.spec_list[index].sku = item.sku.split(',')
              data.spec_list[index].name = data.spec_list[index].sku.join('-')
            })
            data.spec.forEach((ite, index) => {
              var arr = JSON.parse(ite.item)
              var arr_item = []
              arr.forEach((ite, ind) => {
                arr_item.push({
                  text: ite,
                })
              })
              data.spec[index].item = arr_item
            })


            this.queryForm.goods_id = row.id
            this.fetchData()

            this.skuList_copy = data.spec_list
            this.SpecificationsList = data.spec
            this.form = data
            if (data.remote_city != null) {
              this.form.remote_city = data.remote_city.split(',')
            }
            this.getTypelist() //商品分类
            index_brand({
              kor_type: data.kor_type
            }).then((res) => {
              this.bidList = res.data
            })
            index_brand_types({
              kor_type: data.kor_type,
              brand_id: data.bid
            }).then((res) => {
              this.brand_typeList = res.data
            })
            this.dialogFormVisible = true
          })
          // --------------------
        })

      }


    },

    fetchData() {

      goodsSkuList(this.queryForm).then(res => {
        this.skuList = res.data.list
        this.total = res.data.count
      })

    },

    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },


    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.skuList = []
      this.SpecificationsList = []
      this.dialogFormVisible = false
      this.value = ''
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {


          console.log(this.form, '9999')


          this.saveLoading = true
          console.log(this.getSkuList(), '121231321')




          this.getSkuList().then((res) => {
            var spec_submit = JSON.parse(
              JSON.stringify(this.SpecificationsList)
            )

            console.log(spec_submit, '98989888')




            spec_submit.forEach((value, index) => {
              spec_submit[index].item_text = []
              value.item.forEach((ite, ind) => {
                spec_submit[index].item_text.push(ite.text)
              })
              spec_submit[index].item = spec_submit[index].item_text
              delete spec_submit[index].item_text
            })
            var spec_list = JSON.parse(JSON.stringify(this.skuList))
            spec_list.forEach((item, index) => {
              delete spec_list[index].name
            })
            // this.form.content = this.value
            this.form.spec = spec_submit
            this.form.spec_list = spec_list

            if (this.form.remote_city.length > 0 && this.form.remote_price == '') {
              this.$message.warning('请输入偏远地区运费价格')
              return
            }

            console.log(this.isShow, '852147')


            if (this.isShow == false) {
              var form = JSON.parse(JSON.stringify(this.form))



              console.log(this.form, 'this.form')
              console.log(form, 'form')

              form.cid = this.form.cid.join(',')
              form.remote_city = this.form.remote_city.join(',')
              goodsAdd(form).then(res => {
                this.$baseMessage(res.msg, 'success')
                this.$emit('fetch-data')
                this.close()
                this.saveLoading = false
              })



            } else {
              var form = JSON.parse(JSON.stringify(this.form))
              form.remote_city = this.form.remote_city.join(',')
              var submit_sku = JSON.parse(JSON.stringify(form.spec_list))
              // 获取删除的skuid
              var old_id = [] //没有被改变的sku
              var old_all_sku_id = [] //最开始的skuid
              submit_sku.forEach((item, index) => {
                if (item.id) {
                  old_id.push(item.id)
                }
              })
              this.skuList_copy.forEach((item, index) => {
                if (item.id) {
                  old_all_sku_id.push(item.id)
                }
              })
              var delID = []
              if (old_id.length > 0) {
                delID = old_all_sku_id.filter(item => !old_id.includes(item));
              } else {
                delID = old_all_sku_id
              }
              delID = delID.join(',')
              form.spec_list_del = delID
              // =====================
              this.$refs['form'].validate(async (valid) => {
                if (valid) {
                  form.cid = this.form.cid.join(',')
                  form.kor_type = String(this.form.kor_type)
                  try {
                    const { msg } = await goodsUpdate(form)
                    this.saveLoading = false
                    this.$baseMessage(msg, 'success')
                    this.$emit('fetch-data')
                    this.close()
                  } catch (error) {
                    // 错误处理
                    this.saveLoading = false
                  }
                } else {
                  this.saveLoading = false
                  return false
                }
              })
            }
          }).catch((err) => {
            this.saveLoading = false
          })




        } else {
          return false
          this.saveLoading = false
        }
      })



















    },
  },
}
</script>
<style scoped lang="scss">
.guige_item {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 15px;
  margin-bottom: 20px;
}

.guige_item_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.guige_item_bottom {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

:deep .el-input--small .el-input__inner {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding-right: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/*  :deep .el-dialog__body {
    height: 63vh;
    overflow: hidden;
    overflow-y: scroll;
  } */
.div_form {
  height: 80vh;
  overflow: hidden;
  overflow-y: scroll;
}

:deep .ql-container {
  height: 400px;
}
</style>
